import SeoAutomation from './SeoAutomation.container';

export default SeoAutomation;
